import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { AppContext, mainAPikey } from "../../../ContextApi";
import { FaDeleteLeft } from "react-icons/fa6";

const EmployeeQueriesForm = ({ categoriesListOption }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileNames, setSelectedFileNames] = useState([""]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({});

  const { requestOptions } = useContext(AppContext);

  const category = watch("category");

  const onSubmit = (data) => {
    
    if(selectedFiles?.length == 0){
      toast.error("Please upload atleast 1 Document");
      return 
    }
    setIsLoading(true);
    
    const formdata = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      formdata.append("documents[]", selectedFiles[i]?.file); // Ensure selectedFiles[i] is a File
    }

    formdata.append("category", data?.category);
    formdata.append("other_info", data?.other_info || "");
    formdata.append("query", data?.query);

    const requestOptionsCopy = {
      ...requestOptions,
      method: "POST",
      body: formdata,
    };

    // Remove content-type header if present:
    if (requestOptionsCopy.headers?.["Content-Type"]) {
      delete requestOptionsCopy.headers["Content-Type"];
    }

    fetch(
      `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/raise-query-ticket`,
      requestOptionsCopy
    )
      .then((response) => response.json())
      .then((res) => {
        setIsLoading(false);
        if (res.success) {
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          reset();
          setSelectedFiles(null)
        } else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error submitting form:", error);
        toast.error("Something went wrong!");
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFiles((files) => [...files, { file }]);
  };

  const handleDeleteFile = (select_file) => {
    setSelectedFiles(() =>
      selectedFiles?.filter(
        (sel_file) => sel_file.file.name !== select_file?.file?.name
      )
    );
  };

  useEffect(() => {
    console.log(selectedCategory);
  }, [selectedCategory]);

  return (
    <div className="employee-queries-form-main-cover">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-input-box mb-3">
              <div className="form-input">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Category <span className="required-input">*</span>
                </label>
                <select
                  {...register("category", {
                    required: "Category is required",
                  })}
                  onChange={(e) => {
                    const selectedOption = categoriesListOption.find(
                      (option) => option.value == e.target.value
                    );
                    console.log(selectedOption)
                    setSelectedCategory(selectedOption?.label || "");
                  }}
                >
                  <option value="">Select a category</option>
                  {categoriesListOption &&
                    categoriesListOption.map((option) => {
                      return (
                        <option value={option.value}>{option.label}</option>
                      );
                    })}
                </select>

                {errors.category && (
                  <small className="text-danger">Category is required</small>
                )}
              </div>
            </div>
          </div>
          {selectedCategory == "Other" && (
            <div className="col-lg-12">
              <div className="form-input-box mb-3">
                <div className="form-input">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Other Category <span className="required-input">*</span>
                  </label>
                  <input
                    type="text"
                    name="other_info"
                    className="form-control"
                    placeholder="Enter Category"
                    {...register("other_info", {
                      required: "other catgory is required",
                    })}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="col-lg-12">
            <div className="form-input-box mb-3">
              <div className="form-input">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Please write your query in the following box{" "}
                  <span className="required-input">*</span>
                </label>
                <textarea
                  className="form-control"
                  id=""
                  aria-describedby="emailHelp"
                  placeholder="Write a query"
                  {...register("query", {
                    required: "query is required",
                  })}
                  rows={3}
                />
                {errors.query && (
                  <small className="text-danger">
                    {errors.query.message || ""}
                  </small>
                )}
              </div>
            </div>
          </div>

          <div className="my-document-wrapper">
            <div className="form-input-box">
              <div className="form-input">
                <label className="form-label upload-label">
                  Upload Document
                </label>
                <div
                  className="upload-area"
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  <span>
                    Click to upload (xls, xlsx, doc, docx, png, jpeg, jpg, pdf)
                  </span>
                </div>
                <input
                  type="file"
                  id="fileInput"
                  accept=".pdf,.png,.jpg,.jpeg"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    handleFileChange(e);
                  }}
                />
              </div>
              {selectedFiles?.map((select_file, index) => (
                <div key={index} className="selected-file-box">
                  <span className="file-name">{select_file?.file?.name}</span>
                  <button
                    className="queries-delete-btn"
                    type="button"
                    onClick={() => handleDeleteFile(select_file)}
                  >
                    <FaDeleteLeft />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="submit-btn-box">
          <input
            disabled={isLoading}
            type="submit"
            className="register-form-btn mt-4 mb-3"
            value={isLoading ? "please wait..." : "Submit"}
          ></input>
        </div>
      </form>
    </div>
  );
};

export default EmployeeQueriesForm;
